import React, { useContext, useEffect, useState } from 'react'
import LeftPanel from '../Element/LeftPanel';
import ChangePassword from './ChangePassword';
import DeleteAccount from './DeleteAccount';
import EditProfile from './EditProfile';
import Template from 'Components/Templates/Template';
import { CLIENT, CLIENTTAB, FIRM, PROFESSIONAL, PROFESSIONALTAB, assistantProfilePanelItems, clientProfilePanelItems, firmProfilePanelItems, funderProfilePanelItems, profilePanelItems, unverifiedProfilePanelItems } from 'Constants';
import ProfilePageRedirect from './ProfilePageRedirect';
import { Context } from 'Context/Context';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Header from 'Components/Header/Header';
import { CiBurger } from 'react-icons/ci';
import { ChevronLeft, Menu, X } from 'lucide-react';
import useIsMobile from 'Hooks/useIsMobile';

function Profile() {
  const {setPanel} = useParams();
  const isMobile = useIsMobile();;
  const panel = setPanel ? setPanel : 0;
  const [panelItems, setPanelItems] = useState(profilePanelItems);
  const [activePanel, setActivePanel] = useState(panel);
  const {userDetails} = useContext(Context)
  const [openMenu, setOpenMenu] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const currentPanel = panelItems?.find((item) => String(item.key) === String(activePanel));
  // Keep the open tab in sync when the URL changes while already on the profile
  // page (e.g. avatar menu shortcuts -> /attorney/profile/6)
  useEffect(() => {
    if(setPanel !== undefined) setActivePanel(setPanel);
  }, [setPanel]);
  useEffect(() => {
                  if(userDetails?.role === CLIENT)
                  {
                    setPanelItems(clientProfilePanelItems);
                  }
                  else if(userDetails?.role === PROFESSIONAL)
                  {
                    if(userDetails?.isUserAssistant)
                    {
                      setPanelItems(assistantProfilePanelItems);
                    }
                    else if(userDetails?.isUserFunder)
                    {
                      setPanelItems(funderProfilePanelItems);
                    }
                    else
                    {
                      if(userDetails?.verified)
                      {
                        setPanelItems(profilePanelItems);
                      }
                      else
                      {
                        setPanelItems(unverifiedProfilePanelItems);
                      }
                    }
                  }
                  else if(userDetails?.role === FIRM)
                  {
                    // no Subscription until the firm's profile is verified
                    setPanelItems(userDetails?.verified ? firmProfilePanelItems : firmProfilePanelItems.filter((item) => item.key !== 7));
                  }
                  else
                  {
                    setPanelItems(profilePanelItems);
                  }
  },[userDetails]);

    return (
      <>
        <Header noSearch={true} noMenu={true} noSubs={true} showDashboard={true}/>
        {
          (!isMobile && userDetails?.role === CLIENT) ?
          <div className='w-full col-span-6 flex font-plexsans' style={{background:'#f7f4ed', minHeight:'calc(100vh - 64px)'}}>
            <div className='flex-none' style={{width:'190px', padding:'26px 0', borderRight:'1px solid rgba(20,33,61,.1)'}}>
              {panelItems?.map((item) => {
                const id = item?.key ? parseInt(item.key) : 0;
                const active = parseInt(activePanel) === id;
                return (
                  <div
                  key={id}
                  onClick={() => setActivePanel(id)}
                  className='cursor-pointer'
                  style={active
                    ? {padding:'12px 24px', font:"600 13px/1 'IBM Plex Sans',sans-serif", color:'#14213d', borderLeft:'2px solid #8a6231', background:'rgba(138,98,49,.06)'}
                    : {padding:'12px 24px', font:"400 13px/1 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.6)', borderLeft:'2px solid transparent'}}
                  >
                    {item.menu}
                  </div>
                )
              })}
            </div>
            <div className='flex-1' style={{padding:'34px 40px', background:'#ffffff'}}>
              <ProfilePageRedirect activePanel={activePanel} setActivePanel={setActivePanel}/>
            </div>
          </div>
          :
          isMobile ?
          <>
            {/* Profile menu drawer (phone) */}
            <div
              onClick={() => setOpenMenu(false)}
              className={`fixed inset-0 bg-navy/[.45] z-40 transition-opacity duration-300 ${openMenu ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            />
            <aside
              className={`fixed top-0 left-0 z-50 h-full w-[85vw] max-w-[320px] bg-cream font-plexsans flex flex-col transform transition-transform duration-300 ease-in-out ${openMenu ? 'translate-x-0 shadow-[0_24px_60px_-20px_rgba(20,33,61,.5)]' : '-translate-x-full shadow-none'}`}
            >
              <div className='flex-none flex items-start justify-between gap-4 py-[18px] px-5 bg-white border-b border-navy/[.1]'>
                <div className='flex flex-col gap-1.5'>
                  <span className='font-plexmono font-medium text-[11px] leading-none tracking-[.08em] uppercase text-brass'>Account</span>
                  <span className='font-spectral text-[19px] leading-[1.25] text-navy'>Settings</span>
                </div>
                <button type='button' onClick={() => setOpenMenu(false)} title='Close' className='flex bg-transparent border-0 cursor-pointer text-navy p-0.5'>
                  <X className='w-[18px] h-[18px]' strokeWidth={2.2}/>
                </button>
              </div>
              <nav className='flex-1 overflow-y-auto py-3'>
                {panelItems?.map((item) => {
                  const active = String(activePanel) === String(item.key);
                  const danger = /delete/i.test(item.menu);
                  return (
                    <button
                      type='button'
                      key={item.key}
                      onClick={() => { setOpenMenu(false); setActivePanel(item.key); }}
                      className={`w-full text-left bg-transparent cursor-pointer border-0 border-l-2 py-3.5 px-5 text-[14px] leading-none ${active ? 'border-brass bg-brass/[.08] font-semibold text-navy' : `border-transparent font-normal ${danger ? 'text-danger' : 'text-navy/[.75]'}`}`}
                    >
                      {item.menu}
                    </button>
                  );
                })}
              </nav>
            </aside>

            <div className='w-full col-span-6 flex flex-col min-h-[calc(100vh-60px)] bg-cream'>
              {/* Which section you're on + a button to switch */}
              <div className='flex items-center justify-between gap-3 py-3 px-4 bg-white border-b border-navy/[.1] font-plexsans'>
                <div className='flex flex-col gap-1 min-w-0'>
                  <span className='font-plexmono font-medium text-[10.5px] leading-none tracking-[.08em] uppercase text-brass'>Account</span>
                  <span className='font-semibold text-[15px] leading-[1.25] text-navy truncate'>{currentPanel?.menu || 'Profile'}</span>
                </div>
                <button type='button' onClick={() => setOpenMenu(true)}
                  className='flex-none inline-flex items-center gap-1.5 font-semibold text-[13px] leading-none text-navy bg-white border border-navy/[.2] rounded-md py-2.5 px-3 cursor-pointer'>
                  <Menu className='w-4 h-4'/> Menu
                </button>
              </div>
              <ProfilePageRedirect activePanel={activePanel} setActivePanel={setActivePanel}/>
            </div>
          </>
          :
          
          <Template
                  leaveTabs={true}
                  panelItems={panelItems}
                  activePanel={activePanel}
                  setActivePanel={setActivePanel}
                  content = {<ProfilePageRedirect activePanel={activePanel} setActivePanel={setActivePanel}/>}
                  />
        }
        
     </>
    )
}

export default Profile